module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cS6dm"))).then(() => parcelRequire('d0iPb'));